<template>
  <sys-mess />
  <div id="main-content-wrapper" class="container-fluid">
    <div class="row pt-4">
      <div class="black-stripe col-12 fixed-top z-index-1"></div>
      <sidenav v-if="this.$store.state.showSidenav" />
      <main
        class="col-12 col-lg-10 main-content position-relative border-radius-lg d-flex flex-column calculated-height z-index-2 px-0 px-md-2"
        :class="this.$store.state.showSidenav ? 'offset-lg-2' : 'mx-auto'">
        <router-view />
      </main>
    </div>
  </div>
  <mobile-menu v-if="this.$store.state.showSidenav" />
  <overlay />
</template>
<script>
import Sidenav from "./views/components/Sidenav";
import MobileMenu from "./views/components/MobileMenu.vue";
import SysMess from "./views/components/Elements/SysMess.vue";
import Overlay from "./views/components/Elements/Overlay.vue";

export default {
  name: "App",
  components: {
    Sidenav,
    MobileMenu,
    SysMess,
    Overlay
  },
  methods: {
    isIOS: function () {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }
  },
  mounted() {
    this.isIOS() ? document.body.classList.add('ios-device') : document.body.classList.remove('ios-device');
  }
};
</script>
<style>
body:not(.ios-device):not(.mobile-message) #app{
  height: 100vh;
}

.black-stripe {
  background: #252321;
  height: 250px;
  widows: 100vw;
}

@media screen and (max-width: 991px) {
  #main-content-wrapper {
    padding-bottom: 60px;
  }

  body.ios-device.mobile-message .calculated-height {
    height: calc(100vh - 180px)
  }
}

@media screen and (min-width: 992px) {
  .calculated-height {
    height: calc(100vh - 24px);
  }
}

@media screen and (max-width: 991px) {
  .calculated-height {
    height: calc(100vh - 100px);
  }
}
</style>
